import React from 'react'

const Complaint = () => {
  return (
    <section className='p-refund-policy'>
            <div className='refund-policy-header'>
                <div>
                    <h1>Compliant Privacy Policy</h1>
                </div>
            </div>
            <div className='refund-policy-text'>
                <div className='sec-head'>
                    <div>
                        <label className='sec-annot'>
                            <span></span> Compliant Privacy Policy
                        </label>
                        {/* <h1>Our refund policy ensures a worry-free shopping experience</h1>
                        <p>
                            By using this website, you explicitly agree to the following terms
                        </p> */}
                    </div>
                </div>
                <div className='refund-policy-list'>

                    <h3 className='refundPolicySecHeading'>LIMITATION OF LIABILITY</h3>
                    <ul><li>TrinovusSolutions LLC is committed to protecting the privacy of our users. This Privacy Policy outlines the types of personal information we collect, how we use it, and the choices available to users regarding their information.</li></ul>

                    
                    <h3 className='refundPolicySecHeading'>Information We Collect</h3>
                    <ul><li>Personal Information: When you visit our website or interact with our services, we may collect personal information such as your name, email address, phone number, and other contact details.</li><li>Usage Data: We may also collect information about how you interact with our website and services, including IP address, browser type, pages visited, and other usage data.</li></ul>

                    
                    <h3 className='refundPolicySecHeading'>How We Use Your Information</h3>
                    <ul><li>We may use the personal information we collect to:</li><li>Communicate with you about our services, promotions, and events.</li><li>Provide customer support and respond to inquiries.</li><li>Customize and improve our website and services.</li><li>Comply with legal obligations.</li><li>Consent to Receive SMS Messages</li><li>By providing your phone number, you consent to receive SMS messages from us regarding our products, services, and promotions. Message and data rates may apply. You can opt out at any time by replying ‘STOP’ to any message.</li></ul>

                    
                    <h3 className='refundPolicySecHeading'>Data Security</h3>
                    <ul><li>We take appropriate measures to protect the security and confidentiality of your personal information. However, please note that no method of transmission over the internet or electronic storage is 100% secure.</li></ul>

                    
                    <h3 className='refundPolicySecHeading'>Third-Party Services</h3>
                    <ul><li>We may use third-party services to assist in operating our website and delivering our services. These third parties have access to your personal information only to perform specific tasks on our behalf and are obligated not to disclose or use it for any other purpose.</li></ul>
                    
                    
                    <h3 className='refundPolicySecHeading'>Protection of Personal Information</h3>
                    <ul><li>We are committed to protecting the privacy and confidentiality of our users’ personal information, including their phone numbers. We will not share, sell, or disclose users’ phone numbers to third parties without their explicit consent, except as required by law or as necessary to provide our services. Your phone number will only be used for the purposes outlined in this Privacy Policy, such as sending SMS messages related to our products, services, promotions, or other communications deemed relevant to you. We implement appropriate technical and organizational measures to safeguard the security and integrity of your personal information.</li></ul>

                    
                    <h3 className='refundPolicySecHeading'>Your Rights</h3>
                    <ul><li>You have the right to access, correct, or delete your personal information. You may also have the right to object to or restrict certain processing of your information. Please contact us to exercise these rights.</li></ul>

                    
                    <h3 className='refundPolicySecHeading'>Changes to This Privacy Policy</h3>
                    <ul><li>We may update our Privacy Policy from time to time. Any changes will be posted on this page, and the effective date will be updated accordingly.</li></ul>
                    
                    
                    <h3 className='refundPolicySecHeading'>Contact Us</h3>
                    <p>If you have any questions or concerns about our Privacy Policy, please contact us at <a href="mailto:info@trinovussolutions.com"><span style={{color:'rgb(34, 227, 9)'}}>info@trinovussolutions.com</span></a></p>


                </div>
            </div>
        </section>
  )
}

export default Complaint